import { memo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useProgress } from "../contexts/progress-context";
import { useMerchantInfo } from "../hooks/use-merchant-info";
import { useProduct } from "../hooks/use-product";
import { withCoverageBuilderView } from "./returns/coverage-builder-view";

export const ProductRedirect = memo(function ProductRedirect() {
  const product = useProduct();
  const location = useLocation();
  const { currentStepId, formData } = useProgress();
  const { featureFlags, loading } = useMerchantInfo();

  if (!product) {
    return <Navigate replace to="/" />;
  }

  if (
    product.id === "shipping-fulfillment" &&
    featureFlags == null &&
    loading
  ) {
    return null;
  }

  let targetStep = product.defaultRoute;
  let targetSearch = location.search;
  if (currentStepId) {
    let resumeStepId = currentStepId;
    if (product.id === "returns" && currentStepId === "ret-return-options") {
      resumeStepId = "ret-return-policy";
    } else if (
      product.id === "returns" &&
      currentStepId === "ret-about-coverage"
    ) {
      resumeStepId = "ret-coverage-widget";
      targetSearch = withCoverageBuilderView(location.search, "about");
    } else if (
      product.id === "returns" &&
      currentStepId === "ret-coverage-widget"
    ) {
      targetSearch = withCoverageBuilderView(
        location.search,
        formData["ret-coverage-widget"]?.version === 2 ? "configure" : "about",
      );
    }
    const validStep = product.steps.find(
      (step) => step.id === resumeStepId && step.resumeEligible !== false,
    );
    if (validStep) {
      targetStep = validStep.path;
    }
  }

  return (
    <Navigate
      replace
      state={location.state}
      to={`/${product.id}/${targetStep}${targetSearch}`}
    />
  );
});
